import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7in1nltx4z: FaireBrandEntity = {
  token: "b_7in1nltx4z",
  type: "brand",
  name: "Pure Drop",
  avatarUrl:
    "https://cdn.faire.com/fastly/7a53d0c0b5c0778d4251e509ff2d40eb4d658ed6d05a9b64992388cb3501ac37.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/af61e9d2b67ddfbc57921fab6053e8d97c683bbdc42acd6ef91785c3a8a0f885.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7a53d0c0b5c0778d4251e509ff2d40eb4d658ed6d05a9b64992388cb3501ac37.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/af61e9d2b67ddfbc57921fab6053e8d97c683bbdc42acd6ef91785c3a8a0f885.jpeg",
  location: "Hacienda Heights, CA, USA",
  minimumOrderDollars: 40,
  rating: 4.9,
  reviewCount: 223,
  isInsider: true,
  description:
    "We have Vegan Handmade Cruelty Free beautiful Bath & Skincare product. More things available at www.puredropshower.com 💕\nYou are welcome to use our photo to sell 💕",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:07.312Z",
    importedBy: "entity-db-cli",
  },
};
